// @ts-nocheck

"use client"

import Image from "next/image"
import React from "react"
import "./styles.scss"

const Title = ({ ean, price, title }) => {
    return (
        <section className="property-title__wrapper">
            <div className="property-title__container">
                <h2 className="property-title__title">{title || ""}</h2>
                <h3 className="property-title__price">{price || ""}</h3>
                <hr className="property-title__line" />
                <h6 className="property-title__ean">{ean || ""}</h6>
            </div>
        </section>
    )
}

const Icons = ({ children }) => {
    return (
        <section className="property-title__icons">
            {children}
        </section>
    )
}

const IconSingle = ({ title, vector, year }) => {
    return (
        <div className="property-title__singleIcons">
            <div className="property-title__singleIcons--icon">
                <Image
                    src={vector || "/images/beluxe/"}
                    alt={title || " "}
                    layout="fill"
                    objectFit="contain"
                    lang="pl"
                    loading="eager"
                    quality={100}
                />
            </div>
            <div className="property-title__singleIcons--title">
                {title || ""}
            </div>
            <div className="property-title__singleIcons--year">
                {year || ""}
            </div>
        </div>
    )
}

const DescriptionAndFeatures = ({ description, features }) => {
    return (
        <section className="property-description__wrapper">
            <div className="property-description__container">
                <div className="property-description__column">
                    <h5 className="property-description__header">{description?.title || ""}</h5>
                    <p className="property-description__content" dangerouslySetInnerHTML={{ __html: description?.content || ""}}/>
                </div>
                <div className="property-description__column">
                    <h5 className="property-description__header">{features?.title || ""}</h5>
                    <ul className="property-description__featuresList">
                        {features && features.content.length > 0 && features.content.map((feature, index) =>
                            feature ? <li key={index} className="property-description__feature">{feature || ""}</li> : null
                        )}
                    </ul>
                </div>
            </div>
        </section>
    )
}

export {
    Title,
    Icons,
    IconSingle,
    DescriptionAndFeatures
}